'use strict';
var BASWebServices;
(function (BASWebServices) {
    var FilenameFilter = (function () {
        function FilenameFilter() {
        }
        FilenameFilter.Factory = function () {
            return function (input) {
                if (angular.isArray(input)) {
                    var filtered = [];
                    angular.forEach(input, function (url) {
                        filtered.push(FilenameFilter.filter(url));
                    });
                    return filtered;
                }
                else if (angular.isString(input)) {
                    return FilenameFilter.filter(input);
                }
                else if (input === 'undefined') {
                    return 0;
                }
                else {
                    return input;
                }
            };
        };
        FilenameFilter.filter = function (url) {
            return url.substring(0, url.lastIndexOf("."));
        };
        return FilenameFilter;
    }());
    BASWebServices.FilenameFilter = FilenameFilter;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=FilenameFilter.js.map